import React from "react";

import linkify from "../linkify";

const findLinks = (contentBlock, callback) => {
  const links = linkify.match(contentBlock.getText());

  (links || []).forEach(({ index, lastIndex }) => (
    callback(index, lastIndex)
  ));
};

const Link = ({ children, decoratedText }) => {
  const href = linkify.match(decoratedText)[0].url;

  return <a className="chq-edi--lk" href={href}>{children}</a>;
};

export default {
  strategy: findLinks,
  component: Link
};
